var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Resolver } from "did-resolver";
import { getResolver as ethrGetResolver } from "ethr-did-resolver";
import { getResolver as webGetResolver } from "web-did-resolver";
import NodeCache from "node-cache";
import { INFURA_API_KEY } from "../config";
import { generateProvider } from "../common/utils";
export var getProviderConfig = function () {
    var _a, _b, _c;
    var provider = generateProvider();
    var rpcUrl = ((_a = provider === null || provider === void 0 ? void 0 : provider.connection) === null || _a === void 0 ? void 0 : _a.url) || "";
    var networkName = ((_b = provider === null || provider === void 0 ? void 0 : provider._network) === null || _b === void 0 ? void 0 : _b.name) === "homestead" ? "mainnet" : ((_c = provider === null || provider === void 0 ? void 0 : provider._network) === null || _c === void 0 ? void 0 : _c.name) || "";
    if (!rpcUrl || !networkName) {
        return { networks: [{ name: "mainnet", rpcUrl: "https://mainnet.infura.io/v3/".concat(INFURA_API_KEY) }] };
    }
    return {
        networks: [{ name: networkName, rpcUrl: rpcUrl }],
    };
};
var didResolutionCache = new NodeCache({ stdTTL: 5 * 60 }); // 5 min
var defaultResolver = new Resolver(__assign(__assign({}, ethrGetResolver(getProviderConfig())), webGetResolver()));
export var createResolver = function (_a) {
    var ethrResolverConfig = _a.ethrResolverConfig;
    return ethrResolverConfig
        ? new Resolver(__assign(__assign({}, ethrGetResolver(ethrResolverConfig)), webGetResolver()))
        : defaultResolver;
};
export var resolve = function (didUrl, resolver) { return __awaiter(void 0, void 0, void 0, function () {
    var cachedResult, didResolutionResult, _a, did;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cachedResult = didResolutionCache.get(didUrl);
                if (cachedResult)
                    return [2 /*return*/, cachedResult];
                if (!resolver) return [3 /*break*/, 2];
                return [4 /*yield*/, resolver.resolve(didUrl)];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, defaultResolver.resolve(didUrl)];
            case 3:
                _a = _b.sent();
                _b.label = 4;
            case 4:
                didResolutionResult = _a;
                did = didResolutionResult.didDocument || undefined;
                didResolutionCache.set(didUrl, did);
                return [2 /*return*/, did];
        }
    });
}); };
export var getVerificationMethod = function (did, key, resolver) { return __awaiter(void 0, void 0, void 0, function () {
    var didDocument;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, resolve(did, resolver)];
            case 1:
                didDocument = _b.sent();
                if (!didDocument)
                    return [2 /*return*/];
                return [2 /*return*/, (_a = didDocument.verificationMethod) === null || _a === void 0 ? void 0 : _a.find(function (k) { return k.id.toLowerCase() === key.toLowerCase(); })];
        }
    });
}); };
